<template>
  <div :class="{'flex-wrap table-filter-item': label}">
    <div v-if="label" class="flex-align-center table-filter-label">{{ label }}：</div>
    <el-select
      v-model="valueBackup"
      :clearable="clearable"
      :multiple="multiple"
      :placeholder="placeholder"
      @change="handleChange"
      filterable
      :size="size"
    >
      <el-option
        v-for="item in list"
        :key="item.value"
        :label="item.name"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
import { cardTicketStates } from '@/enums/cardTicketStates';

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Array],
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    clearable: Boolean,
    size: {
      type: String,
      default: 'medium',
    },
    placeholder: {
      type: String,
      default: '请选择课次券状态',
    },
  },
  data: () => ({
    valueBackup: null,
    list: cardTicketStates,
  }),
  watch: {
    value: {
      handler(value) {
        if (this.multiple) {
          const arr = Array.isArray(value) ? [...value] : [];
          if (JSON.stringify(arr) !== JSON.stringify(this.valueBackup)) {
            this.valueBackup = arr;
          }
        } else {
          const v = +value || '';
          if (v !== this.valueBackup) this.valueBackup = v;
        }
      },
      immediate: true,
    },
    valueBackup(valueBackup) {
      if (this.multiple) {
        this.$emit('input', valueBackup || []);
      } else {
        if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
      }
    },
  },
  methods: {
    handleChange(valueBackup) {
      this.$emit('change', valueBackup);
    },
  },
};
</script>
